import type { CoordinatesIO } from '@/api';

export default class Coordinates implements CoordinatesIO {
    latitude = 0;
    longitude = 0;

    constructor(data: CoordinatesIO) {
        Object.assign(this, data);
    }
}
